import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { context } from '../../../../globalState/GlobalState';
import './css/AlreadyPurchasedLink.css';

const ORDERS_URL = 'https://optimxsports.com/orders';

const TEXT = {
    purchase: 'Already purchased? View or update your order',
    receipt: 'Find this order later at optimxsports.com/orders',
};

const AlreadyPurchasedLink = (props) => {
    const { variant, align } = props;
    const { globalState } = useContext(context);

    const href = globalState.teamId ? `${ORDERS_URL}?team=${encodeURIComponent(globalState.teamId)}` : ORDERS_URL;

    return (
        <p className={`already-purchased-link-container already-purchased-link-${align}`}>
            <a
                className="already-purchased-link"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
            >
                {TEXT[variant] || TEXT.purchase}
            </a>
        </p>
    );
};

AlreadyPurchasedLink.propTypes = {
    variant: PropTypes.oneOf(['purchase', 'receipt']),
    align: PropTypes.oneOf(['left', 'center', 'right']),
};

AlreadyPurchasedLink.defaultProps = {
    variant: 'purchase',
    align: 'center',
};

export default memo(AlreadyPurchasedLink);
